export const validVideoFileExtensions = ["mov", "mkv", "mp4", "avi", "mpg"]
export const validAudioFileExtensions = ["mp3"]
export const validSubtitleFileExtensions = ["srt"]